export default __webpack_public_path__ + "static/media/Wealth-Secure-plus-Brochure.b30d4be7.pdf";